<template>
    <div>
        <el-upload
            ref="upload"
            action=""
            class="upload-demo"
            :http-request="submitUpload"
            :show-file-list="false"
            :auto-upload="true"
            accept="image/jpeg,image/jpg,image/png"
            >
            <el-button type="primary" icon="el-icon-plus" circle></el-button>
        </el-upload>
    </div>
</template>
<script>
import { uploadPictures } from '../../api/product';
const BYTES_PER_CHUNK = 5 * 1024 * 1024;
export default {
    methods: {
        submitUpload(uploadData) {
            if (uploadData.file.type === 'image/jpeg' || uploadData.file.type === 'image/jpg' || uploadData.file.type === 'image/png') {
                if (uploadData.file.size > BYTES_PER_CHUNK) {
                    this.$message({
                        message: '图片上传只支持5M以内',
                        type: 'warning'
                    });
                    this.$refs.upload.clearFiles();
                } else {
                    this.simpleUpload(uploadData);
                }
            } else {
                this.$message({
                    message: '图片上传类型不正确',
                    type: 'warning'
                });
                this.$refs.upload.clearFiles();
            }
            // if (uploadData.file.size > BYTES_PER_CHUNK) {
            //     this.$message({
            //         message: '图片上传只支持5M以内',
            //         type: 'warning'
            //     });
            //     this.$refs.upload.clearFiles();
            // } else {
            //     this.simpleUpload(uploadData);
            // }
        },
        // 图片上传测试
        simpleUpload(uploadData) {
            const form = new FormData();
            form.append('file', uploadData.file);
            uploadPictures(form).then(res => {
                if (res.code === '0') {
                    this.$emit('pushImg', res.data.downUrl);
                    this.$refs.upload.clearFiles();
                }
            }).catch(() => {
                this.$refs.upload.clearFiles();
            });
        }
    }
};
</script>
<style lang="less">

</style>